import { useNavigate } from 'react-router-dom';
import { ExoticPlaces } from '../../../dummyData/homePage';
import './exotic.css';
import { useState } from 'react';
import MobileCarouselCom from '../../../components/mobCarousel/MobileCarousel';

const ExoticSection = () => {
    const navigate = useNavigate();
    const [limit] = useState(9);

    const handleNavigate = (path) => {
        navigate(`/search-result/trip/${path}`, {
            state: { limit }
        });
    };
    return (
        <div className='customContainer featuresSection'>
            <div style={{ textAlign: 'center' }}>
                <p className='pageCount'>Exotic</p>
                <p className='homeTitle'>Go Exotic Places</p>
            </div>

            <div className='featureWrapper mobHidden'>
                {ExoticPlaces.slice(0, 3).map((item) => {
                    return (
                        <div onClick={() => handleNavigate(item.title)} key={item.id} className='feature'>
                            <img src={item.image} alt={item.title} loading='lazy' decoding='async' />
                            <span className='featureCount'>{item.count} Tours</span>
                            <span className='featureTitle'>{item.title}</span>
                        </div>
                    );
                })}
            </div>

            <div className='featureWrapperRowTwo mobHidden'>
                {ExoticPlaces.slice(3, 7).map((item, index) => {
                    if (index < 3) {
                        return (
                            <div onClick={() => handleNavigate(item.title)} key={item.id} className='feature'>
                                <img src={item.image} alt={item.title} loading='lazy' decoding='async' />
                                <span className='featureCount'>{item.count} Tours</span>
                                <span className='featureTitle'>{item.title}</span>
                            </div>
                        );
                    } else {
                        return (
                            <div key={item.id} className='feature featureBorder'>
                                <img src={item.image} alt={item.title} loading='lazy' decoding='async' />
                                <span className='featureCount firstTimeDiscount'>UP TO 50% Off</span>
                                <span className='firstBookingTitle'>
                                    Your <br /> First Booking
                                </span>
                                <button className='viewDetailsBtn' onClick={() => handleNavigate('Trek')}>
                                    View Details
                                </button>
                            </div>
                        );
                    }
                })}
            </div>
            <div className='mobDisplay'>
                <MobileCarouselCom type='feature' data={ExoticPlaces} />
            </div>
        </div>
    );
};

export default ExoticSection;
